import { Component, EventEmitter, Input, OnInit, Output, ViewChild, HostListener } from '@angular/core';
import { EmailEditorComponent } from 'angular-email-editor';
import { ToastrService } from 'ngx-toastr';
import { EmailTemplateService } from 'src/app/private/services/email-tempate.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Platform } from '@angular/cdk/platform';
import { UploadService } from 'src/app/private/services/upload.service';
import { HttpEventType } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var unlayer: any;
@Component({
  selector: 'app-create-email-template',
  templateUrl: './create-email-template.component.html',
  styleUrls: ['./create-email-template.component.scss']
})
export class CreateEmailTemplateComponent implements OnInit {

  @Input() type: any;
  @Input() templateDataToEdit: any;
  title = 'angular-email-editor';
  pageTitle = 'Create';

  htmlData = '';
  design = '';
  options = {
    // setting previw to mobile
    mobile: true,
    appearance: {
      theme: { name: 'dark', isDark: true},
      panels: {
        tools: {
          dock: 'right' as 'right',
        }
      }
    },
    tools: {

    },
    features: {
      preview: true,
      stockImages: true,
      undoRedo:true,
    },
    locale: 'en-US',
    customCSS: [

    ]
  }

  btnLoading = false;

  formData = {
    templateName: '',
    templateCategory: '',
    status: '',
    responseType: 'interested_not_interested',
    attachments: [] as File[]
  };

  // Attachment preview URLs
  attachmentPreviews: any[] = [];
  selectedAttachment: any = [];
  selectedIndex: any = 0;
  
  
  // Upload tracking
  uploadingFiles: Set<string> = new Set();
  uploadedFileUrls: any[] = [];

  dynamicFields = ['firstName', 'lastName', 'email']; 
  editorLoadedFlag = false;
  allLeadFeilds: any = [];
  filteredLeadFields: any = [];
  signatures: any = [];
  templateVariables :any = [];
  
  // Search and filter
  searchQuery: string = '';
  
  // Category expansion state
  expandedCategories = {
    signatures: true,
    fields: true
  };
  
  // Drag state
  isDragging = false;
  currentDragField: string = '';

  dataLoading = false;
  isSignatureDraging = false;


  @ViewChild(EmailEditorComponent)
  private emailEditor!: EmailEditorComponent;

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() reload: EventEmitter<any> = new EventEmitter();

  constructor(
    private toast: ToastrService,
    private api: EmailTemplateService,
    private localStorage: LocalStorageService,
    private api2: LeadService,
    private platform: Platform,
    private uploadService: UploadService,
    private modalService: NgbModal

  ) {

  }

  //testing:
    isMobile = false;
    editor: any;
    openEditor = false;
  //

  isMobileView(): boolean{
    return this.platform.ANDROID || this.platform.IOS || window.innerWidth <= 768;
  }
  
  private touchStartX = 0;
  private touchStartY = 0;
  private draggedField: string | null = null;
  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    const target = event.target as HTMLElement;
    if (target.hasAttribute('draggable')) {
      this.draggedField = target.getAttribute('data-field') || '';
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      this.editorLoadedFlag = true;
    
      // For signatures
      if (target.classList.contains('signature-item')) {
      this.isSignatureDraging = true;
      }
  }
}

@HostListener('touchmove', ['$event'])
onTouchMove(event: TouchEvent) {
  if (this.draggedField) {
    // Calculate movement to determine if it's a deliberate drag
    const touch = event.touches[0];
    const moveX = Math.abs(touch.clientX - this.touchStartX);
    const moveY = Math.abs(touch.clientY - this.touchStartY);
    
    // Consider it a drag if moved more than 10px
    if (moveX > 10 || moveY > 10) {
      event.preventDefault(); // Prevent scrolling while dragging
    }
  }
}

@HostListener('touchend', ['$event'])
@HostListener('touchcancel', ['$event'])
onTouchEnd(event: TouchEvent) {
  if (this.draggedField) {
    const touch = event.changedTouches[0];
    const dropElement = document.elementFromPoint(touch.clientX, touch.clientY);
    
    // Check if dropped on the editor
    if (dropElement?.closest('.email-editor-container')) {
      this.insertPlaceholder(this.draggedField);
    }
    
    this.draggedField = null;
    this.editorLoadedFlag = false;
    this.isSignatureDraging = false;
  }
}

  closeModal() {
    this.close.emit();
  }

  ngOnInit() {
    if (this.type === 'edit') {
      this.pageTitle = 'Edit';
      this.formData.templateName = this.templateDataToEdit.template_name;
      this.formData.templateCategory = this.templateDataToEdit.template_category;
      this.formData.status = this.templateDataToEdit.status;
      this.formData.responseType = this.templateDataToEdit.response_type || 'interested_not_interested';
      this.htmlData = this.templateDataToEdit.template_body;

      this.templateVariables = this.templateDataToEdit.variables || [];
      
      // Load existing attachments
      if (this.templateDataToEdit.attachments && this.templateDataToEdit.attachments.length > 0) {
        this.loadExistingAttachments(this.templateDataToEdit.attachments);
      }
    }
    this.getLeadsFields();
    this.signatures = this.localStorage.getSignatures();
    console.log('Loaded signatures:', this.signatures);
    console.log('Signatures count:', this.signatures?.length || 0);
    this.isMobile = window.innerWidth < 1024;
    this.filteredLeadFields = [...this.allLeadFeilds];
  }
  
  // Load existing attachments for edit mode
  loadExistingAttachments(attachments: any[]) {
    attachments.forEach((attachment: any) => {
      // Add to uploaded URLs
      this.uploadedFileUrls.push({
        fileName: attachment.fileName || this.getFileNameFromUrl(attachment.url),
        url: attachment.url
      });
      
      // Create preview
      const fileName = attachment.fileName || this.getFileNameFromUrl(attachment.url);
      const fileExtension = this.getFileExtension(fileName);
      const preview = this.getPreviewFromExtension(fileExtension);
      
      this.attachmentPreviews.push({
        file: null, // No actual file object for existing attachments
        preview: preview,
        name: fileName,
        size: attachment.size || 'Unknown size',
        uploading: false,
        uploadProgress: 100,
        isExisting: true // Flag to identify existing attachments
      });
    });
  }
  
  // Extract filename from URL
  getFileNameFromUrl(url: string): string {
    const parts = url.split('/');
    return parts[parts.length - 1];
  }
  
  // Get file extension
  getFileExtension(fileName: string): string {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  }
  
  // Get preview icon based on file extension
  getPreviewFromExtension(extension: string): string {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
    const pdfExtensions = ['pdf'];
    const wordExtensions = ['doc', 'docx'];
    const excelExtensions = ['xls', 'xlsx'];
    const pptExtensions = ['ppt', 'pptx'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv'];
    const audioExtensions = ['mp3', 'wav', 'ogg'];
    const zipExtensions = ['zip', 'rar', '7z'];
    
    if (imageExtensions.includes(extension)) {
      return 'fa-file-image';
    } else if (pdfExtensions.includes(extension)) {
      return 'fa-file-pdf';
    } else if (wordExtensions.includes(extension)) {
      return 'fa-file-word';
    } else if (excelExtensions.includes(extension)) {
      return 'fa-file-excel';
    } else if (pptExtensions.includes(extension)) {
      return 'fa-file-powerpoint';
    } else if (videoExtensions.includes(extension)) {
      return 'fa-file-video';
    } else if (audioExtensions.includes(extension)) {
      return 'fa-file-audio';
    } else if (zipExtensions.includes(extension)) {
      return 'fa-file-archive';
    } else {
      return 'fa-file';
    }
  }
  
  onInsertToEditor(value: string) {
  this.editor?.editor?.insertText(value);
}

  // Insert signature with flag set
  insertSignature(signature: string) {
    console.log('=== INSERT SIGNATURE (Click) ===');
    this.isSignatureDraging = true;
    this.insertPlaceholder(signature);
  }

  async onSubmit(form: any) {
    if (form.valid) {

      // Check if any files are still uploading
      if (this.uploadingFiles.size > 0) {
        this.toast.warning('Please wait for all files to finish uploading');
        return;
      }

      try {

        this.btnLoading = true;
        await this.exportHtml();

        const payload = {
          client_id: this.localStorage.getClientId(),
          template_body: this.htmlData,
          template_name: this.formData.templateName,
          template_category: this.formData.templateCategory,
          attachments: this.uploadedFileUrls, // Send uploaded URLs
          template_design: JSON.stringify(this.design),
          status: this.formData.status,
          user_id: this.localStorage.getUserId(),
          variables: this.templateVariables,
          response_type: this.formData.responseType || 'interested_not_interested'
        }


        if (this.type === 'edit') {

          const payload2 = {
            client_id: this.localStorage.getClientId(),
            template_id: this.templateDataToEdit.template_id,
            template_body: this.htmlData,
            template_design: JSON.stringify(this.design),
            template_name: this.formData.templateName,
            template_category: this.formData.templateCategory,
            attachments: this.uploadedFileUrls, // Send uploaded URLs
            status: this.formData.status,
            user_id: this.localStorage.getUserId(),
            variables: this.templateVariables,
            response_type: this.formData.responseType || 'interested_not_interested'
          }

          this.api.updateTemplate(payload2).subscribe(
            (res: any) => {
              this.reload.emit();
            },
            (error: any) => {
              console.log('Error:', error);
              this.btnLoading = false;
              this.toast.error('Error updating template');
            }
          );
        } else {
          this.api.createTemplate(payload).subscribe(
            (res: any) => {
              console.log('Response:', res);
              this.reload.emit();
            },
            (error: any) => {
              console.log('Error:', error);
              this.btnLoading = false;
              this.toast.error('Error creating template');
            }
          );
        }

      } catch (e) {
        console.log('Error:', e);
        this.btnLoading = false;
        this.toast.error('Error creating template');
      }

    } else {
      // If form is invalid, mark all fields as touched to show validation errors
      Object.keys(form.controls).forEach(field => {
        const control = form.controls[field];
        control.markAsTouched({ onlySelf: true });
      });
    }
  }


  // called when the editor is created
  editorLoaded() {
    console.log('Editor loaded event fired');
    const iframe = document.querySelector('iframe');
    this.editor = (iframe as any)?.contentWindow?.unlayer;
    console.log('Editor reference:', this.editor);
    console.log('EmailEditor component:', this.emailEditor);
  }



  // called when the editor has finished loading
  editorReady() {

    setTimeout(() => {
      if (this.type === 'edit') {

        try {
          this.emailEditor.editor.loadDesign(
            JSON.parse(this.templateDataToEdit.template_design)
          );
        } catch (error) {
          console.error('Error loading design:', error);
        }
      }
    }, 500);
  }

  async exportHtml(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.emailEditor.editor.exportHtml((data: any) => {
        if (data && data.html) {
          console.log('Exported HTML:', data.design);
          this.htmlData = data.html;
          this.design = data.design;
          resolve(); // Resolve the promise once data is available
        } else {
          reject('Error exporting HTML');
        }
      });
    });
  }


  insertPlaceholder(field: string) {
    // Check if editor is ready
    if (!this.emailEditor || !this.emailEditor.editor) {
      console.error('Email editor is not ready');
      this.toast.error('Please wait for the editor to load');
      return;
    }

    let placeholder = '';
    if(this.isSignatureDraging){
      placeholder = `${field}`;
    }else{
      placeholder = `{{${field}}}`;
    }
    const variableKey = field.replace(/^contact_/, ''); // remove prefix if present
    
    // Add to template variables if not already present
    if (!this.templateVariables.includes(variableKey)) {
      this.templateVariables.push(variableKey);
    }

    console.log('Inserting placeholder:', placeholder);
    console.log('Template variables:', this.templateVariables);

    this.emailEditor.editor.exportHtml((data: any) => {
      const design = data.design;

      // Ensure the `rows` array exists in the design body
      if (!design.body.rows) {
        design.body.rows = [];
      }

      if (design.body.rows.length === 0) {
        // If no rows exist, add a new row
        const newRow = {
          id: `row_${Date.now()}`, // Generate a unique ID for the row
          cells: [1], // Define the cell count
          columns: [
            {
              id: `col_${Date.now()}`, // Generate a unique ID for the column
              contents: [
                {
                  type: 'text', // Text content type
                  values: {
                    text: `<span>${placeholder}</span>`, // The placeholder text wrapped in <p>
                  }
                }
              ],
              values: {
                backgroundColor: "",
                padding: "0px",
                border: {},
                borderRadius: "0px",
                _meta: {
                  htmlID: `u_column_${Date.now()}`, // Unique HTML ID
                  htmlClassNames: "u_column"
                }
              }
            }
          ],
          values: {
            displayCondition: null,
            columns: false,
            _styleGuide: null,
            backgroundColor: "",
            columnsBackgroundColor: "",
            backgroundImage: {
              url: "",
              fullWidth: true,
              repeat: "no-repeat",
              size: "custom",
              position: "center",
              customPosition: ["50%", "50%"]
            },
            padding: "0px",
            anchor: "",
            hideDesktop: false,
            _meta: {
              htmlID: `u_row_${Date.now()}`, // Unique HTML ID
              htmlClassNames: "u_row"
            },
            selectable: true,
            draggable: true,
            duplicatable: true,
            deletable: true,
            hideable: true
          }
        };

        // Append the new row to the rows array
        design.body.rows.push(newRow);
      } else {
        console.log('Appending to existing content');
        // If rows exist, append the placeholder to the last column in the last row
        const lastRow = design.body.rows[design.body.rows.length - 1];
        const lastColumn = lastRow.columns[lastRow.columns.length - 1]; // Get the last column

        console.log('lastRow:', lastRow);
        console.log('lastColumn:', lastColumn);

        if (lastColumn.contents && lastColumn.contents.length > 0) {
          // Append the placeholder to the `text` of the last content item in the last column
          const lastContent = lastColumn.contents[lastColumn.contents.length - 1];
          if (lastContent.type === 'text' && lastContent.values && lastContent.values.text) {
            // Append the placeholder to existing text
            const currentText = lastContent.values.text.replace(/<\/?p>/g, ''); // Remove any existing <p> tags if present
            lastContent.values.text = `<p>${currentText}<span>${placeholder}</span></p>`; // Append the placeholder inside the <p> tag
          } else {
            // If the last content is not text, add a new text content with the placeholder
            lastColumn.contents.push({
              type: 'text',
              values: {
                text: `<span>${placeholder}</span>`
              }
            });
          }
        } else {
          // If the last column has no contents, initialize it with the placeholder
          lastColumn.contents = [
            {
              type: 'text',
              values: {
                text: `<span>${placeholder}</span>`
              }
            }
          ];
        }
      }


      console.log('Modified Design:', design);

      // Load the modified design back into the editor
      this.emailEditor.editor.loadDesign(
        JSON.parse(JSON.stringify(design ? design : ''))
      );
      
      // Reset drag states
      this.isSignatureDraging = false;
      this.isDragging = false;
      this.currentDragField = '';
      
      // Show success message
      this.toast.success('Variable inserted successfully');
    });
  }



  onDragStart(event: DragEvent, field: string) {
    console.log('=== DRAG START (Contact Field) ===');
    console.log('Field value:', field);
    console.log('Event:', event);
    // Store the field value in the dataTransfer object
    event.dataTransfer?.setData('text', field);
    this.editorLoadedFlag = true;
    this.isDragging = true;
    this.currentDragField = field;
    console.log('Drag state set - editorLoadedFlag:', this.editorLoadedFlag);
  }

  onDragStart2(event: DragEvent, field: string) {
    console.log('=== DRAG START (Signature) ===');
    console.log('Signature value:', field);
    console.log('Event:', event);
    // Store the field value in the dataTransfer object
    event.dataTransfer?.setData('text', field);
    this.editorLoadedFlag = true;
    this.isSignatureDraging = true;
    this.isDragging = true;
    this.currentDragField = field;
    console.log('Drag state set - isSignatureDraging:', this.isSignatureDraging);
  }

  // This method allows the drop by preventing the default behavior
  onDragOver(event: DragEvent) {
    console.log('Drag over event:', event);
    event.preventDefault();
   
  }

  onDragEnd(event: DragEvent) {
    console.log('Drag end event:', event);
    event.preventDefault();
    this.editorLoadedFlag = false;
    this.isDragging = false;
    this.currentDragField = '';
  }

  
  onDragEnd2(event: DragEvent) {
    console.log('Drag end event:', event);
    event.preventDefault();
    this.editorLoadedFlag = false;
    this.isSignatureDraging = false;
    this.isDragging = false;
    this.currentDragField = '';
  }

  // This method handles the drop and calls insertPlaceholder
  onDrop(event: DragEvent) {
    console.log('=== DROP EVENT ===');
    console.log('Drop event:', event);
    console.log('Event target:', event.target);
    event.preventDefault();
    event.stopPropagation();
    
    const field = event.dataTransfer?.getData('text'); // Retrieve the dragged field
    console.log('Retrieved field from dataTransfer:', field);
    console.log('Is signature dragging:', this.isSignatureDraging);
    
    this.editorLoadedFlag = false;
    this.isDragging = false;
    this.currentDragField = '';
    
    if (field) {
      console.log('Calling insertPlaceholder with field:', field);
      // Insert the field as-is without removing any prefix
      this.insertPlaceholder(field);
    } else {
      console.error('No field data found in dataTransfer');
      this.toast.error('Failed to insert variable - no data found');
    }
  }

  getLeadsFields() {
    // id = this.localStorage.getClientId()
    let param = {
      client_id:  this.localStorage.getClientId(),
    };
    this.dataLoading = true;

    this.allLeadFeilds.push({key: 'Name', value: 'name'});
    this.allLeadFeilds.push({key: 'Email', value: 'email'});
    this.allLeadFeilds.push({key: 'Phone', value: 'phone'});
    // this.allLeadFeilds.push({key: 'Company', value: 'company_name'});
    // this.allLeadFeilds.push({key: 'Lead Source', value: 'lead_source'});


    // this.api2.getLeadsFields(param).subscribe({
    //   next: (data) => {
    //     this.dataLoading = false;

    //     const newFiled = data.fields?.map((element: any) => {
    //       return {
    //         key : element.label,
    //         value :  element.field_name
    //       }}
    //     );

    //     this.allLeadFeilds = [...this.allLeadFeilds, ...newFiled];
       

    //   },
    //   error: (e) => {
    //     this.dataLoading = false;
    //     console.error(e);
    //   },
    // });
    
    // Initialize filtered fields
    this.filteredLeadFields = [...this.allLeadFeilds];
  }

  // Handle file selection and upload to S3
  onFileSelect(event: any) {
    const files: FileList = event.target.files;
    
    if (files && files.length > 0) {
      // Limit to 5 attachments
      const remainingSlots = 5 - this.formData.attachments.length;
      const filesToAdd = Math.min(files.length, remainingSlots);
      
      if (filesToAdd < files.length) {
        this.toast.warning(`Maximum 5 attachments allowed. Adding first ${filesToAdd} files.`);
      }
      
      for (let i = 0; i < filesToAdd; i++) {
        const file = files[i];
        
        // Check file size (max 10MB per file)
        if (file.size > 10 * 1024 * 1024) {
          this.toast.error(`File "${file.name}" exceeds 10MB limit`);
          continue;
        }
        
        // Add to formData
        this.formData.attachments.push(file);
        
        // Generate preview
        const preview = this.getFilePreview(file);
        const previewObj = {
          file: file,
          preview: preview,
          name: file.name,
          size: this.formatFileSize(file.size),
          uploading: true,
          uploadProgress: 0
        };
        
        this.attachmentPreviews.push(previewObj as any);
        
        // Upload to S3
        this.uploadToS3(file, this.attachmentPreviews.length - 1);
      }
    }
    
    // Reset input
    event.target.value = '';
  }

  // Upload file to S3
  uploadToS3(file: File, index: number) {
    const formData = new FormData();
    const clientId = this.localStorage.getClientId();
    
    formData.append('file', file);
    formData.append('folders', `crm/attachments/${clientId}`);
    formData.append('bucket', 'global-upload-storage');
    formData.append('client_id', clientId);
    
    this.uploadingFiles.add(file.name);
    
    this.uploadService.uploadDocumentsWithProgress(formData).subscribe({
      next: (event: any) => {
        if (event.type === 'progress') {
          // Update progress
          this.attachmentPreviews[index].uploadProgress = event.progress;
        } else if (event.type === 'response') {
          // Upload complete
          this.attachmentPreviews[index].uploading = false;
          this.attachmentPreviews[index].uploadProgress = 100;
          this.uploadingFiles.delete(file.name);
          
          // Store the uploaded URL
          if (event.body && event.body.url) {
            this.uploadedFileUrls.push({
              fileName: file.name,
              url: event.body.url
            });
            this.toast.success(`${file.name} uploaded successfully`);
          }
        }
      },
      error: (error) => {
        console.error('Upload error:', error);
        this.toast.error(`Failed to upload ${file.name}`);
        this.uploadingFiles.delete(file.name);
        this.attachmentPreviews[index].uploading = false;
        
        // Remove failed upload from list
        this.removeAttachment(index);
      }
    });
  }

  // Get file preview icon/image
  getFilePreview(file: File): string {
    const fileType = file.type;
    
    if (fileType.startsWith('image/')) {
      return URL.createObjectURL(file);
    } else if (fileType === 'application/pdf') {
      return 'fa-file-pdf';
    } else if (fileType.includes('word') || fileType.includes('document')) {
      return 'fa-file-word';
    } else if (fileType.includes('excel') || fileType.includes('spreadsheet')) {
      return 'fa-file-excel';
    } else if (fileType.includes('powerpoint') || fileType.includes('presentation')) {
      return 'fa-file-powerpoint';
    } else if (fileType.startsWith('video/')) {
      return 'fa-file-video';
    } else if (fileType.startsWith('audio/')) {
      return 'fa-file-audio';
    } else if (fileType === 'application/zip' || fileType === 'application/x-zip-compressed') {
      return 'fa-file-archive';
    } else {
      return 'fa-file';
    }
  }

  // Preview attachment in modal
  previewAttachment(index: number, previewModal: any) {
    const attachment = this.attachmentPreviews[index];
    
    if (!attachment) {
      this.toast.error('Attachment not found');
      return;
    }
    
    // Prepare attachment data for preview modal
    let attachmentUrl = null;
    
    // For existing attachments, use the URL from uploadedFileUrls
    if (attachment.isExisting) {
      const uploadedFile = this.uploadedFileUrls.find(u => u.fileName === attachment.name);
      if (uploadedFile) {
        attachmentUrl = uploadedFile.url;
        
      }
    } else {
      // For new uploads, check if it's an image with blob URL
      if (attachment.preview && attachment.preview.startsWith('blob:')) {
        attachmentUrl = attachment.preview;
      } else {
        // Use the uploaded URL from S3
        const uploadedFile = this.uploadedFileUrls.find(u => u.fileName === attachment.name);
        if (uploadedFile) {
          attachmentUrl = uploadedFile.url;
        }
      }
    }
   
    
    // Check if we have a valid URL
    if (!attachmentUrl) {
      if (attachment.uploading) {
        this.toast.warning('Please wait for the file to finish uploading');
      } else {
        this.toast.error('Preview not available for this file');
      }
      return;
    }
    
    const attachmentData = {
      name: attachment.name,
      file_name: attachment.name,
      url: attachmentUrl,
      publicUrl: attachmentUrl,
      size: attachment.size,
      type: this.getFileTypeFromName(attachment.name),
      mime_type: this.getMimeTypeFromName(attachment.name)
    };
    
    // Store for template binding
    this.selectedAttachment = []
    this.selectedAttachment.push(attachmentData);
    this.selectedIndex = index;
    
    console.log('Opening preview for:', attachmentData);
    
    // Open modal
    const modalRef = this.modalService.open(previewModal, { 
      size: 'xl', 
      centered: true,
      backdrop: 'static',
      windowClass: 'attachment-preview-modal'
    });
    
  }
  
  // Get MIME type from filename
  getMimeTypeFromName(fileName: string): string {
    const extension = this.getFileExtension(fileName);
    const mimeTypes: { [key: string]: string } = {
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'webp': 'image/webp',
      'svg': 'image/svg+xml',
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'mp4': 'video/mp4',
      'avi': 'video/x-msvideo',
      'mov': 'video/quicktime',
      'mp3': 'audio/mpeg',
      'wav': 'audio/wav',
      'zip': 'application/zip'
    };
    
    return mimeTypes[extension] || 'application/octet-stream';
  }
  
  // Get file type from filename
  getFileTypeFromName(fileName: string): string {
    const extension = this.getFileExtension(fileName);
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    const pdfExtensions = ['pdf'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];
    const audioExtensions = ['mp3', 'wav', 'ogg', 'aac'];
    
    if (imageExtensions.includes(extension)) {
      return 'image';
    } else if (pdfExtensions.includes(extension)) {
      return 'pdf';
    } else if (videoExtensions.includes(extension)) {
      return 'video';
    } else if (audioExtensions.includes(extension)) {
      return 'audio';
    } else {
      return 'other';
    }
  }

  // Remove attachment
  removeAttachment(index: number) {
    const preview = this.attachmentPreviews[index];
    
    // Revoke object URL if it's an image blob
    if (preview.preview && preview.preview.startsWith('blob:')) {
      URL.revokeObjectURL(preview.preview);
    }
    
    // Remove from uploadedFileUrls if it exists there
    const fileName = preview.name;
    const urlIndex = this.uploadedFileUrls.findIndex(u => u.fileName === fileName);
    if (urlIndex !== -1) {
      this.uploadedFileUrls.splice(urlIndex, 1);
    }
    
    // Remove from formData.attachments (only for new uploads, not existing)
    if (!preview.isExisting && this.formData.attachments.length > index) {
      this.formData.attachments.splice(index, 1);
    }
    
    // Remove from preview array
    this.attachmentPreviews.splice(index, 1);
  }

  // Format file size
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }
  
  // Search and filter methods
  filterVariables() {
    if (!this.searchQuery || this.searchQuery.trim() === '') {
      this.filteredLeadFields = [...this.allLeadFeilds];
      return;
    }
    
    const query = this.searchQuery.toLowerCase().trim();
    this.filteredLeadFields = this.allLeadFeilds.filter((field: any) => {
      return field.key.toLowerCase().includes(query) || 
             field.value.toLowerCase().includes(query);
    });
  }
  
  clearSearch() {
    this.searchQuery = '';
    this.filteredLeadFields = [...this.allLeadFeilds];
  }
  
  // Category toggle
  toggleCategory(category: 'signatures' | 'fields') {
    this.expandedCategories[category] = !this.expandedCategories[category];
  }



}
